import { useNavigate, useParams } from 'react-router-dom'
import { NavBar } from 'components/NavBar/NavBar'
import { Container, ContainerContent } from 'components/Containers/Containers'
import { Button } from 'components/ui/Button/Button'
import { Flex, H1WithBack, PageWrapper } from 'styling/GlobalStyles'
import { BodyText, OtherText } from 'styling/Typography'
import { IOpsHorizonLane } from 'types/operationsControl.interface'
import { USE_OPS_MOCKS } from 'pages/Operations/Shared/opsControl'
import { OPS_HORIZON_LANES } from 'pages/Operations/Shared/opsControlMocks'
import { DemoBadge } from 'pages/Operations/Shared/OpsSharedComponents'
import {
  BlockChip,
  BlockLabel,
  BoardWrap,
  EmptyStateWrap,
  LaneLabel,
  LaneRow,
  LaneTrack,
  LegendItem,
  LegendRow,
  LegendSwatch,
  ResourceTag,
  RulerRow,
  RulerSpacer,
  RulerTick,
  RulerTrack,
} from './RollingHorizonBoard.styled'

const WINDOW_MIN = 360

const TICKS = ['Now', '+1h', '+2h', '+3h', '+4h', '+5h', '+6h']

const LEGEND = [
  { kind: 'active', label: 'Happening now' },
  { kind: 'assigned', label: 'Up next' },
  { kind: 'proposed', label: 'Planned' },
  { kind: 'blocked', label: 'Blocked' },
] as const

export const RollingHorizonBoard = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const lanes: IOpsHorizonLane[] = USE_OPS_MOCKS ? OPS_HORIZON_LANES : []
  const openPlan = () => navigate(`/operations/plans/${id}`)

  return (
    <>
      <NavBar />
      <PageWrapper>
        <Flex center gap='0.75rem'>
          <H1WithBack title='Upcoming work' arrow onClick={openPlan} />
          <DemoBadge />
        </Flex>
        <Flex mb='16'>
          <OtherText grey>What each machine and person is doing over the next 6 hours</OtherText>
        </Flex>
        {lanes.length === 0 ? (
          <Container>
            <ContainerContent>
              <EmptyStateWrap>
                <BodyText grey>No upcoming work queued yet. Check the plan status.</BodyText>
                <Button variant='secondary' onClick={openPlan}>
                  Open plan
                </Button>
              </EmptyStateWrap>
            </ContainerContent>
          </Container>
        ) : (
          <Container>
            <ContainerContent>
              <BoardWrap>
                <RulerRow>
                  <RulerSpacer />
                  <RulerTrack>
                    {TICKS.map((tick, index) => (
                      <RulerTick key={tick} $index={index}>
                        {tick}
                      </RulerTick>
                    ))}
                  </RulerTrack>
                </RulerRow>
                {lanes.map((lane) => (
                  <LaneRow key={lane.id}>
                    <LaneLabel>
                      <BodyText weight='600'>{lane.resource}</BodyText>
                      <ResourceTag>{lane.resourceType}</ResourceTag>
                    </LaneLabel>
                    <LaneTrack>
                      {lane.blocks.map((block) => (
                        <BlockChip
                          key={block.id}
                          $kind={block.kind}
                          $left={(block.startMin / WINDOW_MIN) * 100}
                          $width={(block.durationMin / WINDOW_MIN) * 100}
                          title={block.label}
                        >
                          <BlockLabel>{block.label}</BlockLabel>
                        </BlockChip>
                      ))}
                    </LaneTrack>
                  </LaneRow>
                ))}
              </BoardWrap>
              <LegendRow>
                {LEGEND.map((item) => (
                  <LegendItem key={item.kind}>
                    <LegendSwatch $kind={item.kind} />
                    <OtherText grey>{item.label}</OtherText>
                  </LegendItem>
                ))}
              </LegendRow>
            </ContainerContent>
          </Container>
        )}
      </PageWrapper>
    </>
  )
}
